@import 'styles/variables';
@import 'styles/mixins';

.content {
  margin-top: -4px;
  margin-left: -8px;
  display: inline-block;
}

.nestedContent {
  margin-left: 8px;
  margin-top: -12px;
}

.leftRail {
  &:before {
    max-height: 30px;
  }
  &:after {
    content: '';
    position: absolute;
    width: 2px;
    left: 15px;
    background-color: #eaecef;
    bottom: -6px;
    top: 34px;
  }

  &.last:after {
    display: none;
  }
}

.icon {
  color: #eaecef;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 26px;

  .dot {
    background-color: currentColor;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 7px;
  }

  .arrow {
    fill: currentColor;
  }
}

.statusName {
  @include md-medium;
  color: var(--neutral-90);
}
